ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
Storage = require 'app/scripts/lib/storage'
_ = require 'underscore'

AUTOJOIN_QUEUE_KEY = 'autoJoinQueue'
ANY_MEMBER = 'any'

# Handle joining board/team invitation links after
# a user confirms their email address
class JoinOnConfirm
  getQueue: ->
    Storage.get(AUTOJOIN_QUEUE_KEY) ? []

  setQueue: (queue) ->
    Storage.set(AUTOJOIN_QUEUE_KEY, queue)

  clearQueue: ->
    Storage.unset(AUTOJOIN_QUEUE_KEY)

  _idMember: ->
    if Auth.isLoggedIn()
      Auth.myId()
    else
      ANY_MEMBER

  _entryForUrl: (apiUrl) ->
    {
      url: apiUrl
      idMember: @_idMember()
    }

  _matchesMember: (id) ->
    id in [ANY_MEMBER, Auth.myId()]

  add: (apiUrl) ->
    queue = @getQueue()
    if _.any(queue, (entry) => entry.url == apiUrl && @_matchesMember(entry.id))
      return

    @setQueue([queue..., @_entryForUrl(apiUrl)])

  inQueue: (apiUrl) ->
    _.any @getQueue(), (entry) =>
      entry.url == apiUrl &&
      @_matchesMember(entry.idMember)

  autoJoin: ->
    queue = @getQueue()
    if queue.length == 0 || !Auth.isLoggedIn()
      return Promise.resolve(false)

    @_runOnce ?= ModelLoader.await('headerData')
    .then =>
      if !Auth.me().get('confirmed')
        return false

      Promise.map queue, (entry) =>
        { url, target, idMember } = entry
        if @_matchesMember(idMember)
          ApiPromise
            method: 'post'
            url: url
          .then ->
            null
          .catch ApiError, ->
            null
        else
          entry
      .then (remainingEntries) =>
        remainingEntries = _.compact(remainingEntries)

        if remainingEntries.length == 0
          @clearQueue()
        else
          @setQueue(remainingEntries)

        # Return true if we joined anything
        remainingEntries.length < queue.length

module.exports = new JoinOnConfirm()
